import Vue from 'vue'
import VueRouter from 'vue-router'
import store from '@/store'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'login',
    component: () => import('../views/login/index.vue'),
    meta: {
      dontRequiresLogin: true
    }
  },
  {
    path: '/login/success',
    name: "login-success",
    component: () => import('../views/login/success.vue'),
  },

  {
    path: '/home',
    name: "home",
    component: () => import('../views/home/index.vue'),
  },
  {
    path: '/student',
    name: "student",
    component: () => import('../views/student/index.vue'),
  },
  // {
  //   path: '/student/info_person',
  //   name: "student/info_person",
  //   component: () => import('../views/student/info_person.vue'),
  // },
  // {
  //   path: '/student/info_home',
  //   name: "student/info_home",
  //   component: () => import('../views/student/info_home.vue'),
  // },
  // {
  //   path: '/student/info_education',
  //   name: "student/info_education",
  //   component: () => import('../views/student/info_education.vue'),
  // },
  // {
  //   path: '/student/info_account',
  //   name: "student/info_account",
  //   component: () => import('../views/student/info_account.vue'),
  // },

  {
    path: '/planning/overview',
    name: "planning/overview",
    component: () => import('../views/planning/overview.vue'),
  },

  {
    path: '/planning/planning_circuit',
    name: "planning/planning_circuit",
    component: () => import('../views/planning/planning_circuit.vue'),
  },

  {
    path: '/planning/planning_general_view',
    name: "planning/planning_general_view",
    component: () => import('../views/planning/planning_general_view.vue'),
  },

  {
    path: '/planning/planning_month_view',
    name: "planning/planning_month_view",
    component: () => import('../views/planning/planning_month_view.vue'),
  },
  {
    path: '/planning/planning_language',
    name: "planning/planning_language",
    component: () => import('../views/planning/planning_language.vue'),
  },
  {
    path: '/planning/planning_gpa',
    name: "planning/planning_gpa",
    component: () => import('../views/planning/planning_gpa.vue'),
  },
  {
    path: '/planning/planning_standardization',
    name: "planning/planning_standardization",
    component: () => import('../views/planning/planning_standardization.vue'),
  },
  {
    path: '/planning/planning_reading',
    name: "planning/planning_reading",
    component: () => import('../views/planning/planning_reading.vue'),
  },

  {
    path: '/planning/planning_competition',
    name: "planning/planning_competition",
    component: () => import('../views/planning/planning_competition.vue'),
  },
  {
    path: '/planning/planning_activity',
    name: "planning/planning_activity",
    component: () => import('../views/planning/planning_activity.vue'),
  },

  {
    path: '/apply/apply_schoolSelection',
    name: "apply/apply_schoolSelection",
    component: () => import('../views/apply/apply_schoolSelection.vue'),
  },

  {
    path: '/apply/apply_materials',
    name: "apply/apply_materials",
    component: () => import('../views/apply/apply_materials.vue'),
  },

  {
    path: '/apply/apply_ps',
    name: "apply/apply_ps",
    component: () => import('../views/apply/apply_ps.vue'),
  },

  {
    path: '/apply/apply_language',
    name: "apply/apply_language",
    component: () => import('../views/apply/apply_language.vue'),
  },

  {
    path: '/apply/apply_standardization',
    name: "apply/apply_standardization",
    component: () => import('../views/apply/apply_standardization.vue'),
  },
  {
    path: '/apply/apply_interview',
    name: "apply/apply_interview",
    component: () => import('../views/apply/apply_interview.vue'),
  },


  {
    path: '/school-admin/list',
    name: "school-admin/list",
    component: () => import('../views/school-admin/list.vue'),
  },

  {
    path: '/teacher',
    name: "teacher",
    component: () => import('../views/teacher/index.vue'),
  },
]

const router = new VueRouter({
  routes
})


router.beforeEach(async (to, from, next) => {
  if (!to.meta.dontRequiresLogin && !store.getters.token && !store.getters.ttoken) {
    next({
      path: '/'
    });
  } else {
    next();
  }

});



export default router
